import { IdentificationType } from '../types/documentType';
import { type FormItemRule } from '@flash-global66/g-form';

/**
 * Genera las reglas de validación para un tipo de identificación
 * @param identificationType - El tipo de identificación seleccionado
 * @param idTypes - Lista de todos los tipos de identificación disponibles
 * @returns Array de reglas de validación
 */
export function generateIdentificationValidationRules(
  identificationType: string,
  idTypes: IdentificationType[]
): FormItemRule[] {
  const selectedType = idTypes.find(
    (item) => item.value === identificationType
  );

  const min = selectedType?.minSize || 2;
  const max = selectedType?.maxSize || 50;

  return [
    { min, message: `Debe tener al menos ${min} caracteres` },
    { max, message: `No puede tener más de ${max} caracteres` },
    {
      trigger: 'blur',
      validator(_: any, value: string) {
        if (!value) {
          return new Error('El campo obligatorio');
        }

        if (!value.match(/^([a-zA-Z0-9]+)$/g)) {
          return new Error('Caracteres no válidos');
        }

        return true;
      },
    },
  ];
}
